export default {
  accesibility: 'Accessibilitat',
  add: 'Afegir',
  add_api_ckan: 'API KCAN disponible',
  add_department: 'Departament',
  add_font: 'Font',
  add_geo: 'Geolocalització',
  add_gerence: 'Gerència',
  add_historic: 'Informació històrica',
  add_long_available: 'Format Long disponible',
  add_more_info: 'Més informació',
  add_publication_date: 'Data de publicació',
  add_publication_freq: 'Freqüència de publicació',
  freq_peticio_negoci: 'Segons disponibilitat/necessitat',
  add_recent_views: 'Visites recents (darreres 2 setmanes)',
  add_title: 'Títol',
  add_token: 'Token requerit',
  add_total_views: 'Visites totals',
  additional: 'Contingut addicional',
  additional_info: 'Informació addicional',
  complement_info: 'Descripció complementària',
  all_dates: 'Totes les dates disponibles',
  all_details: 'Tots els detalls',
  all_ditricts: 'Tots els districtes',
  all_sources: 'Tots els tipus',
  all_subthemes: 'Tots els subtemes',
  all_themes: 'Tots els temes',
  alphabetical_asc: 'Alfabètic A->Z',
  alphabetical_des: 'Alfabètic Z->A',
  APPS: 'App',
  back: 'Tornar',
  bcn_search_placeholder: 'Cercar a barcelona.cat...',
  btn_apply: 'Aplica',
  btn_clean: 'Neteja',
  camps_definition_title: 'Definició dels camps',
  cancel: 'Cancel·lar',
  check_results_apl: 'Consultar Resultats en Aplicatiu',
  check_results_app: "Consultar Resultats a l'App",
  edit_table_title: 'Editar taula',
  contact: 'Contacte',
  copy_link: "Copia l'enllaç",
  cover_title: 'Barcelona Dades',
  data_api: 'Data Api',
  date_latest: 'Data més antiga',
  date_newest: 'Data més recent',
  dates_from: 'Dades de ',
  det_downloads: 'Descarregues totals per ID',
  det_downloads_abs: 'Descarregues totals',
  det_format: 'Format',
  det_last_update: 'Darrera modificació',
  det_map_view: 'Visualitza mapa',
  det_open_freq: "Grau d'obertura",
  det_publish_date: 'Data de publicació',
  det_req_token: 'Token requerit',
  detail: 'Detall',
  district: 'Districtes de Barcelona',
  DOCS: 'Document',
  docs_lab: 'Documents',
  download: 'Descarregar',
  download_links: 'Links de descàrrega',
  download_pdf: 'Descarregar PDF',
  drag_dimensions: 'Afegir dimensió',
  enq_afi: 'Afixació',
  enq_companies: 'Empreses designades',
  enq_contract_conditions: 'Condicions de contracte',
  enq_date_campo: 'Data de realització del treball de camp',
  enq_error_sample: 'Error de mostreig',
  enq_methodology: 'Metodologia',
  enq_num_register: 'Nombre de registre',
  enq_pond: 'Ponderació',
  enq_presu: 'Pressupost (euros)',
  enq_promotor: 'Organisme promotor',
  enq_sample_procedure: 'Procediment de mostreig',
  enq_size_mue: 'Mida de la mostra',
  enq_tipology: 'Tipologia',
  enq_universe: 'Univers',
  enq_validation_date: 'Data de validació',
  enq_date_from: "Data d'inici",
  enq_date_to: 'Data de fi',
  doc_auth: 'Autor',
  doc_subj: 'Matèria',
  doc_geo: 'Cobertura geogràfica',
  doc_publish: 'Publicat per',
  doc_ext: 'Extensió',
  doc_note: 'Nota',
  doc_terms_use: "Condicions d'ús",
  doc_related: 'Document relacionat',
  doc_colections: 'Apareix a les col·leccions',
  show_pdf: 'Vegeu PDF',
  show_txt: 'Vegeu TXT',
  SURVEY: 'Enquesta',
  error_response: 'Error de resposta a la petició',
  error_server_response: 'Error de la cerca al servidor',
  STATISTICS: 'Taula estadística',
  file_chart: 'Gràfica',
  file_details: 'Detalls arxiu',
  file_details_title: "Detalls de l'arxiu",
  file_map: 'Mapa',
  file_table: 'Taula',
  filter_by: 'Filtrar per',
  lang_ca: 'Català',
  lang_en: 'English',
  lang_es: 'Castellano',
  last_3_months: 'Darrers 3 mesos',
  last_informed_date: 'Darrera data informada ',
  last_month: 'Darrer mes',
  last_year: 'Darrer any',
  legal_adv: 'Avís legal',
  license: 'Llicència',
  loading: 'Carregant...',
  manual_range: 'Rang manual',
  MAPS: 'Mapa',
  MICRODATA: 'Microdada',
  no_results_search: 'No hem trobat resultats per la teva cerca',
  no_results_tip: 'Et recomanem aplicar altres filtres de cerca o canviar la paraula introduïda',
  relevance: 'Rellevància',
  results_for: 'resultats per ',
  rows_of: ' files de ',
  search_placeholder: 'Cerca per paraula...',
  share: 'Compartir',
  sort_by: 'Ordena per:',
  subtheme: 'Subtema',
  table_columns: 'Columnes',
  table_filters: 'Altres dimensions',
  table_rows: 'Files',
  table_reset: "Tornar a l'original",
  table_ord_asc: 'Ordre ascendent',
  table_ord_desc: 'Ordre descendent',
  table_select_range: 'Seleccionar rang:',
  tooltip_edit_table: 'Editar taula',
  tooltip_edit_chart: 'Editar gràfic',
  tooltip_edit_map: 'Editar mapa',
  tooltip_two_dim: 'Màxim $n dimensions',
  theme: 'Tema',
  type: 'Tipus',
  download_file: 'Descarregar arxiu',
  type_content: 'Tipus de contingut',
  update_date: "Data d'actualització",
  use_identifier: 'Siusplau, utilitzeu aquest identificador per citar o enllaçar aquest ítem: ',
  views_last_year: ' visualitzacions',
  welcome_to_portal: 'O bé selecciona el tema',
  line_apearence: 'Aparença de la línia',
  line_values: 'Mostrar valors dels punts',
  line_labels: 'Mostrar etiquetes de líní',
  chart_legend_title: 'Llegenda',
  chart_horizontal: 'Horitzontal',
  chart_vertical: 'Vertical',
  chart_line_round: 'Arrodonida',
  chart_line_rect: 'Recta',
  chart_categorical: 'Categòrica',
  chart_unicolor: 'Unicolor',
  chart_orientation: 'Orientació',
  chart_color: 'Color',
  chart_x_axis: 'Orientació etiqueta Eix X',
  chart_y_axis: 'Orientació etiqueta Eix Y',
  chart_labels: 'Mostrar etiquetes de barra',
  chart_values: 'Mostrar valors de barres',
  chart_heat_values: 'Mostrar valors',
  chart_legend: 'Mostrar llegenda',
  chart_config: 'Configuració',
  data_config: 'Data',
  table_chart: 'Dimensió visualitzada',
  calculating: 'Recalculant...',
  used_unit: 'Unitat: ',
  bar_chart: 'Gràfic de Barres',
  stacked_bar_chart: 'Gràfic de Barres Apilades',
  grouped_bar_chart: 'Gràfic de Barres Agrupades',
  line_chart: 'Gràfic de Línies',
  pie_chart: 'Gràfic de Pastís',
  pyramid_chart: 'Piràmide',
  treemap: 'Quadrificació',
  radar_chart: 'Radar',
  connected_dotplot: 'Diagrama de punts',
  heatmap: 'Mapa de calor',
  first_trim: '1r tr',
  second_trim: '2n tr',
  third_trim: '3r tr',
  fourth_trim: '4t tr',
  first_sem: '1r sem',
  second_sem: '2n sem',
  table_compact: 'Compacta',
  table_detail: 'Detallada',
  table_column: 'Columna',
  select_all: 'Seleccionar totes',
  of: ' de ',
  num_cols: ' columnes',
  el_labels: 'Veure noms dels elements',
  value_in_labels: 'Mostrar valor a etiquetes',
  configure_your_table: 'Error de configuració en les dades. Revisa les dimensions.',
  no_data_for_these_filters: 'No hi ha dades per a aquests filtres.',
  too_much_data:
    'No es pot mostrar la gràfica (max 500 cel·les). Canvieu la selecció de filtres per veure aquesta gràfica.',
  bcn_data: 'Barcelona al dia',
  show_less: "Veure'n menys",
  show_more: "Veure'n més",
  unselect_all: 'Desseleccionar totes',
  all_op: 'Tots',
  no_op: 'Cap',
  selected: ' seleccionats',
  map_prev: "Link a l'aplicatiu de mapa",
  color_op: 'Paleta de colors',
  colors_by_value: 'Colors segons valor',
  colors_by_category: 'Colors segons categoria',
  transparency: 'Transparència',
  steps: 'Passos',
  head_us: 'Qui som',
  head_help: 'Ajuda',
  week: 'Setmana',
  meta_id: "Enllaç de l'aplicació",
  DATASTORIES: 'Data Stories',
  datastory_info: 'Consultar Informe Data Story',
  service_unsupported: 'Servei no soportat',
  map_step_linear: 'Lineal',
  map_step_rounded: 'Valors arrodonits',
  map_step_quantile: 'Quantils',
  map_step_breaks: 'Pauses naturals',
  show_points: 'Mostrar punts',
  meta_filters: 'Filtres -> ',
  meta_filters_type: 'Tipus Filtre -> ',
  calendar: 'Calendari',
  no_map_preview: 'Previsualització del mapa no disponible',
  color_flip: 'Canvia ordre de colors',
  datastory_title: 'Data Stories',
  dtst_interactiveapps: 'Aplicacions interactives',
  dtst_reports: 'Informes',
  dtst_pdfdocuments: 'Documents PDF',
  dtst_observatory: 'Observatoris',
  datastory_desc_prev: "Informació d'anàlisi per temes en diversos formats de consulta.",
  news_title: 'Notícies',
  news_desc: 'Estigues al dia del que passa a Barcelona',
  calendar_title: 'Agenda',
  calendar_desc: "Assabenta't de quan publiquem temes del teu interès",
  new: 'Nou',
  update: 'Actualització',
  retard: 'Canvi de data',
  add_to_calendar: 'Afegir al calendari',
  notice_prev: 'Notícia anterior',
  notice_next: 'Notícia següent',
  see_id: "Vegeu l'indicador",
  datastory_desc:
    "Els Data Stories ofereixen una visió analítica sobre diferents aspectes de la ciutat. S'ofereixen en diferents formats com aplicacions interactives, informes, documents PDF i observatoris.",
  datastory_desc2: 'Seleccioneu aquest enllaç si voleu accedir a tota la selecció de Data Stories ',
  copy: 'Copiar dades',
  more_op: 'Més opcions',
  map_step_custom: 'Salt de mapa personalitzat',
  custom_steps: 'Salts personalitzats',
  normalize_axes: 'Normalitzar eixos',
  no_date_selected: 'Cap data seleccionada',
  no_date_events: 'No hi ha cap esdeveniment per a la data seleccionada.',
  geo_not_supported: 'Mapa no disponible',
  page_not_available: 'Aquesta pàgina no existeix. Torna a la portada.',
  backend_error: 'El recurs no esta accessible al openData',
  not_csv: 'csv no trobat',
  not_cms: 'Contingut del CMS no disponible',
  related_content: 'Contingut relacionat',
  data_and_resources: 'Dades més recents',
  lat: 'Latitud',
  lng: 'Longitud',
  login: 'Inicia sessió',
  email: 'Direcció de correu electrònic',
  email_ex: 'nom@correu.com',
  client_id: 'ClientID',
  ask_client_id: 'Sol·licitar ClientID',
  client_id_required: "Es necessari disposar d'un ClientId per l'ús d'aquesta API",
  how_to_get_client:
    "Per aconseguir un ClientId, a la teva zona d'usuari, a la pestanya de dades personals trobaràs un botó per sol·licitar aquesta clau única i personal.",
  user_zone: 'Accedeix a les teves ',
  password: 'Contrasenya',
  password_ex: 'Introdueix la teva contrasenya',
  password_forgot: 'Has oblidat la contrasenya?',
  session_remember: 'Mantenir la sessió iniciada',
  not_member: 'Encara no ets membre?',
  want_register: 'Vull registrar-me',
  register: 'Registrar-se',
  required_field: '* Camp obligatori',
  reg_name: 'Nom',
  reg_name_ex: 'Introdueix el teu nom',
  reg_sur: 'Cognoms',
  reg_sur_ex: 'Introdueix els teus cognoms',
  reg_email_con: 'Confirmar correu electrònic*',
  reg_lang: 'Llengua',
  reg_sex: 'Sexe',
  sex_M: 'Home',
  sex_F: 'Dona',
  sel_placeholder: 'Selecciona una opció',
  reg_pass_con: 'Verificar contrasenya*',
  password_req: 'La contrasenya ha de tenir com a mínim',
  pass_req1: '8 caràcters',
  pass_req2: '1 majúscula',
  pass_req3: '1 minúscula',
  pass_req4: '1 número',
  terms_and_cond: 'clàusula de privacitat',
  reg_dates_prot:
    'Estic informat de la política de protecció de dades i dono consentiment al tractament del les meves dades de caràcter personal',
  reg_more_inf: 'Podeu trobar la informació del tractament 0690 en aquest enllaç: ',
  want_login: 'Ja tens un compte? ',
  my_space: 'El meu espai',
  user_dates: "Dades d'usuari",
  fav_list: 'Llista de preferits',
  view_lib: 'Biblioteca de vistes',
  comun_pref: 'Preferències de comunicacions',
  drop_out: 'Donar-se de baixa',
  last_mod: 'Darrera modificació ',
  email_low: 'Correu electrònic',
  save: 'Guardar',
  tem_new_cont: 'Sobre quins temes vols rebre informació quan afegim nous continguts?',
  temp_freq_news: 'Selecciona la temporalitat i freqüència dels avisos que desitges rebre:',
  temp_none: 'Cap',
  temp_month: 'Mensual',
  temp_week: 'Setmanal',
  favs_for: 'preferits per ',
  update_noti: 'Notificar actualitzacions',
  saved: 'Guardat',
  agree: 'Acceptar',
  location: 'Territori',
  all_locations: 'Totes els territoris',
  supramunicipal: 'Supramunicipal',
  municipi: 'Municipi',
  districte: 'Districte',
  barri: 'Barri',
  area_estadistica_basica: 'Àrea Estadística Bàsica',
  seccio_censal: 'Secció Censal',
  codi_postal: 'Codi postal',
  and: 'i',
  dia: 'Diari',
  setmana: 'Setmanal',
  mes: 'Mensual',
  trimestre: 'Trimestral',
  any: 'Anual',
  all_filters: 'Tots els temes',
  logout: 'Tancar sessió',
  activate_title: 'Confirma el teu email per acabar el registre',
  confirm: 'Confirmar',
  invalid_title: 'Usuari no validat',
  invalid_desc:
    "Les teves dades són correctes però el teu email no ha estat confirmat. Revisa la teva safata d'entrada o fes click en el botó de sota per tornar a enviar un altre correu de validació a l'email registrat.",
  send: 'Tornar a enviar',
  forgot_desc:
    'Introdueix la teva adreça de correu electrònic per enviar un email de recuperació i poder canviar la teva contrasenya.',
  registred_user: 'Usuari registrat correctament',
  validate_desc:
    "Revisa la teva safata d'entrada o fes click en el botó de sota per tornar a enviar un altre correu de validació a l'email registrat.",
  valid_title: 'El teu usuari ja està actiu',
  valid_desc: "Ves a la pàgina d'iniciar sessió i comença a guardar les teves dades.",
  password_title: "La teva contrasenya ja s'ha actualitzat",
  password_desc: "Ves a la pàgina d'iniciar sessió per veure els canvis.",
  change_pw_title: 'Canvia la teva contrasenya',
  change_pw_desc: 'Omple els següents camps per finalitzar el canvi de contrasenya',
  new_pw: 'Nova contrasenya',
  conf_new_pw: 'Confirmar nova contrasenya',
  error_login: 'Usuari o contrasenya incorrectes',
  delete_user:
    'Introdueix la teva adreça de correu electrònic i fes click en el botó confirmar per eliminiar el teu usuari de la base de dades',
  delete_user_confirm:
    "L'usuari s'ha eliminat correctament del sistema i ja no es troba registrat.",
  delete_thanks: 'Gràcies per utilitzar els nostres serveis.',
  drop_out_confirm: 'Segur que et vols donar de baixa?',
  head_links: "Webs d'interès",
  pref_noti_title: 'Permetre notificacions de contingut actualitzat',
  pref_noti_desc:
    'Quan les notificacions estan actives, pots escollir rebre les que són rellevants per a tu',
  pref_noti_active: 'Activades',
  error_token: 'Token invalid o caducat',
  create_newest: 'Data de creació més recent',
  create_latest: 'Data de creació més antiga',
  data_error: 'Error en les dades',
  pref_noti_favs_default_title: 'Notificar actualitzacions dels nous preferits',
  pref_noti_favs_default_desc:
    "(Canviar l'estat per defecte de les notificacions en els nous preferits agregats)",
  email_send: 'Correu electrònic enviat',
  email_desc: "Comprova la teva safata d'entrada i revisa els darrers correus rebuts",
  sex_NS: 'No definit',
  no_views_fav:
    "No s'han trobat vistes per els filtres seleccionats, afegeix nous favorits des de les vistes d'indicadors estadístics",
  no_favs: 'Encara no tens elements a la llista de favorits.',
  no_favs_ex: "Comença a afegir-los des de les diferents pàgines d'indicadors.",
  reg_req: 'Aquest camp no pot estar buit.',
  reg_email: 'Aquest camp no pot estar buit i ha de seguir el format de correu electrònic.',
  reg_email_conf:
    "Aquest camp no pot estar buit i ha de coincidir amb l'altre correu electrònic introduït.",
  reg_pass: 'Aquest camp no pot estar buit i ha de seguir el format de contrasenya requerit.',
  reg_pass_conf: "Aquest camp no pot ser buit i ha de coincidir amb l'altre contrasenya.",
  reg_check: 'Cal acceptar les condicions per completar el registre.',
  api_micro_title: 'Microdata/Export',
  api_def: 'Definició del mètode de la API: ',
  api_micro_def_res: '/microdata/export',
  api_func: 'Funcionalitat: ',
  api_micro_func_res:
    "Obté el fitxer CSV amb les dades d'un dels recursos d'un indicador concret de tipus microdades a partir de l'identificador de l'indicador i del recurs. L'usuari del Portal de Dades, seleccionarà l'element, de tipus microdades, del que vol veure la informació de la llista d'elements que se li presentaran al frontend, fet això seleccionarà el fitxer a descarregar.",
  api_micro_ex: 'Exemple: ',
  api_res:
    "Tot seguit es pot veure un exemple de resultat d'una crida a aquest endpoint amb els paràmetres d'aquest arxiu:",
  api_stat_title: 'Estadístiques/Export',
  api_stat_def_res: '/statistic/export',
  api_stat_func_res:
    "Obté un fitxer en format CSV o Excel amb la taula de dades de l'indicador associat a l'identificador passat com a paràmetre.",
  api_stat_ex_1: 'Exemple (Excel): ',
  api_stat_ex_2: 'Exemple (CSV): ',
  api_extra:
    "Per descarregar aquests arxius des d'una altre aplicació cal utilitzar aquesta instrucció:",
  statistics: 'Estadístiques',
  copied: 'Copiat!',
  unique_values: 'Valors únics',
  valid: 'Vàlids',
  missing: 'Falten',
  most_common: 'Més comú',
  average: 'Mitjana',
  deviation: 'Desviació',
  others: 'Altres',
  count: 'Nombre',
  single_value: 'Valor únic',
  unique_date: 'Única data disponible: ',
  microdata_loader:
    'Estem calculant els detalls de les columnes. Aquests seran visibles passats 30 segons aproximadament.',
  home: 'Home',
  stat_content: 'Estadístiques de contingut',
  stat_use: "Estadístiques d'ús",
  profiles_use: "Perfils d'ús",
  last_week: 'Última setmana',
  pbd_content_title_char_1: "Evolució nombre d'ítems per tipus de fitxer",
  pbd_content_title_char_2: 'Distribució per tipus de fitxer',
  pbd_content_title_char_3: 'Evolució dels ítems per temàtiques',
  pbd_content_title_char_4: 'Distribució per temàtiques',
  pbd_use_title_char_1: "Nombre d'accessos a la web",
  pbd_use_title_char_2: "Evolució del nombre d'usuaris registrats",
  pbd_use_title_char_3: 'Ítems més consultats',
  pbd_use_title_char_4: 'Ítems més descarregats',
  pbd_use_title_char_5: 'Paraules més cercades',
  pbd_profiles_title_char_1: 'Idioma',
  pbd_profiles_title_char_2: 'Dispositiu',
  pbd_profiles_title_char_3: 'País',
  pbd_profiles_title_char_4: 'Hora',
  all_types: 'Tots els tipus',
  add_range: 'Rang de valors',
  add_filter: 'Filtre per tipus',
  add_search: 'Filtre per paraula',
  users: 'Usuaris',
  interactions: 'Interaccions',
  user_blocked: "Usuari bloquejat per l'administrador",
  MON: 'Dl.',
  TUE: 'Dm.',
  WED: 'Dc.',
  THU: 'Dj.',
  FRI: 'Dv.',
  SAT: 'Ds.',
  SUN: 'Dg.',
  quote_and_license: "Condicions d'ús",
  location_type: 'Tipus de territori',
  map_base: 'Base',
  map_no_base: 'Sense Base',
  page_429: 'Dades no disponibles temporalment, torna a intentar-ho més tard',
  overwrite: 'Sobrescriure',
  copy_embed: "Copiar codi d'incrustació",

  meta_description:
    'Integra i difon dades i anàlisi de la situació actual i l’evolució de Barcelona des de les vessants demogràfica, econòmica, social, política i de la percepció ciutadana.',
  meta_keywords:
    "Oficina Municipal de Dades, OMD, Departament d'estadística, Difusió de dades, Enquestes, Estudis d'Opinió, Registre d'enquestes, Ajuntament de Barcelona, Gabinet Tècnic de Programació, estadística, estadístiques, open data, dades obertes, Barcelona, BCN, Anuari estadístic, població, economia, treball, medi urbà, transports, mobilitat, habitatge, societat, política, administració municipal, cartografia Barcelona.",
  embed: 'Incrustar',
  dropdown_index: 'Índex desplegable',
  index: 'Índex',
  not_cms_lang: 'Informe no disponible per aquest idioma',
  register_required: "Es necessari tenir un usuari personal per fer ús d'aquesta api",
  how_to_register: 'Per tenir aquest usuari només necessites omplir el següent formulari: ',
  if_user: 'Si ja tens un usuari fes clic al botó superior per iniciar sessió.',
  client_id_pending: 'Client id sol·licitat i pendent de validació',
  login_advantages: "Descobreix els avantatges d'estar registrat prement ",
  here: 'aquí',
  session_ended: 'La teva sessió ha finalitzat, fes click aquí per tornar a accedir:',
  tornarPrincipal: 'Tornar a la pantalla principal',
  add_dades_alt_valor: 'Dades alt valor',
}
